<template>
  <select ref="select" data-width="100%" @change="$emit('input', $event.target.value)">
    <option v-if="includeBlank" value=""></option>
    <option v-for="[value, label] in options" :key="value" :value="value">{{ label }}</option>
  </select>
</template>
<script>
export default {
  name: 'selectpicker',
  props: {
    options: {
      type: Array,
      required: true
    },
    value: {
      type: String,
      required: false
    },
    includeBlank: {
      type: Boolean,
      default: false
    }
  },
  mounted: function () {
    $(this.$refs.select).selectpicker();
    $(this.$refs.select).selectpicker('val', this.value);
  },
  watch: {
    value: function (newValue) {
      $(this.$refs.select).selectpicker('val', newValue);
    }
  }
};
</script>
